import { styled } from "@mui/material";

export const ListValuesContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(1),
  display: "flex",
  flexDirection: "column"
  
}))

export const ListValuesItem = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  marginBottom: theme.spacing(1),
  display: "flex",
  alignItems: "center",
  borderRadius: 4,

  "input": {
    flexGrow: 1,
    outline: "none",
    border: "none",
    height: 28,
    background: "none",
    color: "white",
    paddingLeft: theme.spacing(1.2),
    fontSize: 11,
    fontFamily: theme.typography.fontFamily
  }
}))